import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

class DynamicDisplay extends React.PureComponent {
  render() {
    const { type, value, t, id } = this.props;

    switch (type) {
      case "TP_NUM":
      case "AMOUNT":
        return <span id={id}>{t("NUMBER", { number: value })}</span>;
      case "TP_TEXT":
        return <span id={id}>{value}</span>;
      case "COMBO":
        return <span id={id}>{value}</span>;
      case "TP_DATE":
      case "YEAR":
      case "MONTHYEAR":
      case "DATE":
        return <span id={id}>{t("DATE", { date: value })}</span>;
      default:
        return <div id={id}>view {type} not found</div>;
    }
  }
}

DynamicDisplay.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.any,
  t: PropTypes.func.isRequired,
  id: PropTypes.string
};

export default compose(withTranslation())(DynamicDisplay);
